import type { IconData } from '@stacksjs/iconify-core'

export const otherUiMagnet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 8A8 8 0 1 1 0 8V4.5h6V10h4V4.5h6zm0-5V0h-6v3zM6 3V0H0v3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiMagnet
